// Initialize all .mdl-video__swiper Swipers
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import { a11y } from './config/a11y';

export function initSwiperVideo() {
    const elements = document.querySelectorAll('.mdl-video__swiper');
    if (!elements.length) return null;

    const instances = [];

    elements.forEach((el) => {
        // Find navigation buttons and pagination in parent container
        const videoWrapper = el.closest('.mdl-video__wrapper');
        const rowContainer = el.closest('.row');
        const nextButton = rowContainer ? rowContainer.querySelector('.swiper-button-next') : null;
        const prevButton = rowContainer ? rowContainer.querySelector('.swiper-button-prev') : null;
        const pagination = el.querySelector('.swiper-pagination');

        const entryCount = parseInt(el.dataset.entries ?? '0', 10);
        const hasMultiple = entryCount >= 2;

        const instance = new Swiper(el, {
            modules: [Navigation, Pagination, A11y, Keyboard],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,

            // No loop for video entries
            loop: false,

            // Accessibility
            a11y,

            // Keyboard navigation (initially disabled)
            keyboard: {
                enabled: false,
                onlyInViewport: true
            },

            // Touch/Mouse behavior
            grabCursor: true,
            touchRatio: 1,
            touchAngle: 45,

            // Performance
            watchSlidesProgress: true,
            preloadImages: false,
            lazy: false,

            // Responsive breakpoints
            breakpoints: hasMultiple ? {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30
                },
                960: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 30
                }
            } : {},

            // Navigation
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'swiper-button-disabled'
            },

            // Pagination
            pagination: {
                el: pagination,
                clickable: true,
                type: 'bullets',
            },

            // Pause all videos when slide changes
            on: {
                slideChange: function (swiper) {
                    const allIframes = swiper.el.querySelectorAll('iframe');
                    allIframes.forEach(iframe => {
                        // Stop YouTube videos
                        if (iframe.src.includes('youtube.com')) {
                            iframe.src = iframe.src;
                        }
                        // Stop Vimeo videos
                        if (iframe.src.includes('vimeo.com')) {
                            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                        }
                    });
                }
            }
        });

        // Enable keyboard navigation only when swiper is focused or hovered
        const enableKeyboard = () => instance.keyboard.enable();
        const disableKeyboard = () => instance.keyboard.disable();

        el.addEventListener('mouseenter', enableKeyboard);
        el.addEventListener('mouseleave', disableKeyboard);
        el.addEventListener('focusin', enableKeyboard);
        el.addEventListener('focusout', disableKeyboard);

        instances.push(instance);
    });

    return instances;
}
